export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/wordpress.2ebd24e.svg";